import { apiDelete } from "../baseApi";

export const deleteUserById = async (id,data={}, cancelToken = null) => {
  try {
    const response = await apiDelete("_domainUser", id, data, { cancelToken });
    return { ...response };
  } catch (error) {
    return Promise.reject(error);
  }
};
